import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import ProjectsPage from "../Pages/ProjectsPage/ProjectsPage";
import ProjectAboutPage from "../Pages/ProjectAboutPage/ProjectAboutPage";
import ProjectDetailsPage from "../Pages/ProjectDetailsPage/ProjectDetailsPage";
import ProjectSectionsPage from "../Pages/ProjectSectionsPage/ProjectSectionsPage";
import ProjectSubSectionsPage from "../Pages/ProjectSubSectionsPage/ProjectSubSectionsPage";
import ProjectWrapperPage from "../Pages/ProjectWrapperPage/ProjectWrapperPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <ProjectsPage /> },
      { path: "project-about/:id/:slug?", element: <ProjectAboutPage /> },
      {
        path: "project",
        element: <ProjectWrapperPage />,
        children: [
          { path: "details/:id/:slug?", element: <ProjectDetailsPage /> },
          { path: "sections/:id/:slug?/:stageIndex", element: <ProjectSectionsPage /> },
          { path: "sub-sections/:id/:slug?/:stageIndex/:sectionIndex", element: <ProjectSubSectionsPage /> },
        ]
      },
    ],
  },
]);
